import { CurrentsAPI, type CurrentsApiConfig } from "@vida/currents-core";
import { getIdToken } from "../auth";
import { getAppsyncEndpoint } from "../config";

let oceanOrgBootstrapPromise: Promise<void> | null = null;

/** Una sola TransactWrite org+catalog per sessione (evita TransactionConflict su query parallele). */
export function ensureOceanOrgBootstrapped(cfg: CurrentsApiConfig): Promise<void> {
  if (!oceanOrgBootstrapPromise) {
    oceanOrgBootstrapPromise = CurrentsAPI.listAgents(cfg)
      .then(() => undefined)
      .catch((err) => {
        oceanOrgBootstrapPromise = null;
        throw err;
      });
  }
  return oceanOrgBootstrapPromise;
}

export function createCurrentsApiConfig(): CurrentsApiConfig {
  return {
    endpoint: getAppsyncEndpoint(),
    getIdToken: () => getIdToken(),
  };
}

export function personalOrgId(sub: string): string {
  return `personal-${sub}`;
}
